import { createAsyncThunk } from '@reduxjs/toolkit';

import { driverAPI } from '@/modules/driver/api';
import { IDriver } from '@/modules/driver/model/driver';
import { namespace } from '@/modules/driver/namespace';
import { setPartnerCity } from '@/modules/partner/actions/actions';
import { PartnerBlockedError } from '@/modules/partner/api';
import { getUserData, ROLES } from '@/modules/user/store/selectors';
import type { RootState } from '@/root-store';

import { setAllDrivers, setMyDriver } from '../actions';

const loadDriver = createAsyncThunk(
  `${namespace}/load-driver`,
  async (_, { dispatch, getState }): Promise<IDriver | undefined> => {
    const me = getUserData(getState() as RootState);

    let driver: IDriver | undefined = undefined;

    if (me.roles.includes(ROLES.PARTNER)) {
      const drivers = await driverAPI.fetchBriefDrivers();

      dispatch(setAllDrivers(drivers.items));
    }

    if (me.roles.includes(ROLES.DRIVER)) {
      driver = await driverAPI.fetchMyDriver();

      dispatch(setMyDriver(driver));

      if (!me.roles.includes(ROLES.PARTNER)) {
        dispatch(setAllDrivers([driver]));
        dispatch(setPartnerCity(driver.cityId));
      }
    }

    if (
      !me.roles.includes(ROLES.FLEET) &&
      !me.roles.includes(ROLES.PARTNER_ASSISTANT) &&
      me.roles.includes(ROLES.DRIVER) &&
      me.roles.includes(ROLES.PARTNER) &&
      // it means the problem is not in expired docs or smth similar
      driver?.accessStatus === 'blocked'
    ) {
      throw new PartnerBlockedError();
    }

    return driver;
  },
);

export { loadDriver };
